import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import RootRef from '../_utils/RootRef';
import classNames from 'classnames';
var disabledStyle = {
  display: 'inline-block',
  cursor: 'not-allowed'
};

var Trigger = /*#__PURE__*/function (_React$Component) {
  _inherits(Trigger, _React$Component);

  var _super = _createSuper(Trigger);

  function Trigger() {
    _classCallCheck(this, Trigger);

    return _super.apply(this, arguments);
  }

  _createClass(Trigger, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          innerRef = _a.innerRef,
          propsStyle = _a.style,
          className = _a.className,
          otherProps = __rest(_a, ["children", "innerRef", "style", "className"]);

      var child = React.Children.only(children);

      var style = _Object$assign({
        pointerEvents: 'none'
      }, child.props.style || {});

      var wrapStyle = _Object$assign(_Object$assign({}, propsStyle), disabledStyle); // @ts-ignore


      var childrenProps = (child || {}).props;

      var _ref = childrenProps || {},
          childStyle = _ref.style,
          childClassName = _ref.className;

      var realStyle = _Object$assign(_Object$assign({}, propsStyle), childStyle);

      var realClx = classNames(childClassName, className);

      if (child.props.disabled) {
        return /*#__PURE__*/React.createElement("span", _Object$assign({
          ref: innerRef,
          style: wrapStyle
        }, otherProps), /*#__PURE__*/React.cloneElement(child, {
          style: style,
          className: realClx
        }));
      }

      return /*#__PURE__*/React.createElement(RootRef, {
        rootRef: innerRef
      }, /*#__PURE__*/React.cloneElement(child, _Object$assign({
        style: realStyle,
        className: realClx
      }, otherProps)));
    }
  }]);

  return Trigger;
}(React.Component);

export default Trigger; // TODO:
// clone 组件会覆盖用户属性，需要解决。